import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { type ReactNode, useEffect, useMemo } from "react";

import { activateLocale, DEFAULT_LOCALE, detectLocale, type SupportedLocale } from "./locale";

interface LocaleProviderProps {
  children: ReactNode;
  initialLocale?: SupportedLocale;
  configLocale?: string;
}

export function LocaleProvider({ children, initialLocale, configLocale }: LocaleProviderProps) {
  const resolvedLocale = useMemo(() => {
    return initialLocale || detectLocale(configLocale);
  }, [initialLocale, configLocale]);

  if (i18n.locale !== resolvedLocale) {
    try {
      i18n.activate(resolvedLocale);
      localStorage.setItem("widget-locale", resolvedLocale);
    } catch (err) {
      console.error("Failed to activate locale, falling back to English:", err);
      i18n.activate(DEFAULT_LOCALE);
    }
  }

  useEffect(() => {
    // biome-ignore lint/suspicious/noExplicitAny: Global debug utility
    (window as any).changeLocale = async (newLocale: SupportedLocale) => {
      await activateLocale(newLocale);
      window.location.reload();
    };
  }, []);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
